import { FSMStages } from "../../types";
export var DEFAULT_TIMEOUT_TIME = 1200000; // 20 minutes

export var isInvalidChangeAction = function isInvalidChangeAction(_ref) {
  var stage = _ref.stage,
    newStage = _ref.newStage,
    authZone = _ref.authZone,
    isOpen = _ref.isOpen,
    blockTime = _ref.blockTime;
  return (
    // Если находимся в АЗ и пытаемся выполнить действия для НЗ
    (newStage === FSMStages.BLOCKED || newStage === FSMStages.CAPTCHA_NEEDED) && authZone === 'authorized' ||
    // Если находимся в НЗ и время блокировки не закончилось
    stage === FSMStages.BLOCKED && blockTime && new Date().getTime() < Number(blockTime) && authZone === 'unauthorized' ||
    // Закрытие сокета при закрытии чата
    !isOpen && newStage !== FSMStages.IDLE
  );
};